import { render, staticRenderFns } from "./onboardingComplete.vue?vue&type=template&id=6a5218d8&scoped=true"
import script from "./onboardingComplete.vue?vue&type=script&lang=js"
export * from "./onboardingComplete.vue?vue&type=script&lang=js"
import style0 from "./onboardingComplete.vue?vue&type=style&index=0&id=6a5218d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5218d8",
  null
  
)

export default component.exports